import React, { useEffect, useState } from "react";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
	dateFormatter,
	buttonsStyle,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { getBlogPostsAdmin, deleteBlogPost, publishBlogPost } from "../../../../api/blog-post";
import { Button, Tooltip, Chip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import PublishIcon from "@material-ui/icons/Publish";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";

function resolveStatus(post) {
	const s = String(post?.status || "").toLowerCase();
	if (s === "draft" || s === "scheduled" || s === "published") return s;
	return post?.published ? "published" : "draft";
}

function statusFormatter(cell, row) {
	const status = row.status || cell;
	const now = Date.now();
	const at = row.publishedAt ? new Date(row.publishedAt).getTime() : null;

	if (status === "draft") {
		return <Chip label="Borrador" size="small" />;
	}
	if (status === "scheduled") {
		const live = at != null && at <= now;
		return (
			<Chip
				label={live ? "Programada (ya visible)" : "Programada"}
				size="small"
				style={{ background: live ? "#1bc5bd" : "#8950fc", color: "#fff" }}
			/>
		);
	}
	return <Chip label="Publicada" size="small" style={{ background: "#1bc5bd", color: "#fff" }} />;
}

function getData(posts) {
	return (posts || []).map((post) => ({
		id: post._id,
		title: post.es?.title || post.en?.title || post.ca?.title || "(sin título)",
		slug: post.es?.slug || post.en?.slug || post.ca?.slug || "—",
		category: post.category,
		status: resolveStatus(post),
		publishedAt: post.publishedAt,
	}));
}

export default function BlogPostsPage() {
	const [data, setData] = useState([]);
	const [postId, setPostId] = useState(null);
	const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
	const [refresh, setRefresh] = useState(false);
	const history = useHistory();

	function buttonFormatter(cell, row) {
		return (
			<>
				{row.status !== "published" && (
					<Tooltip title="Publicar ahora">
						<Button
							style={buttonsStyle}
							size="small"
							onClick={() => {
								publishBlogPost(cell, true)
									.then((res) => {
										if (res.status === 200) {
											alertSuccess({
												title: "Hecho",
												customMessage: "Entrada publicada.",
											});
											setRefresh(true);
										}
									})
									.catch((error) => {
										alertError({ error, customMessage: "No se pudo publicar." });
									});
							}}
						>
							<PublishIcon />
						</Button>
					</Tooltip>
				)}
				<Tooltip title="Editar">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={() => history.push("/edit-blog-post/" + cell)}
					>
						<EditIcon />
					</Button>
				</Tooltip>
				<Tooltip title="Eliminar">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={() => {
							setPostId(cell);
							setOpenConfirmDialog(true);
						}}
					>
						<DeleteIcon />
					</Button>
				</Tooltip>
			</>
		);
	}

	const columns = [
		{ dataField: "title", text: "Título", sort: true },
		{ dataField: "slug", text: "Slug", sort: true },
		{ dataField: "category", text: "Categoría", sort: true },
		{ dataField: "status", text: "Estado", formatter: statusFormatter, sort: true },
		{
			dataField: "publishedAt",
			text: "Fecha",
			formatter: dateFormatter,
			sort: true,
		},
		{
			dataField: "id",
			text: "",
			formatter: buttonFormatter,
			searchable: false,
		},
	];

	useEffect(() => {
		getBlogPostsAdmin()
			.then((res) => {
				if (res.status === 200) {
					setData(getData(res.data));
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({ customMessage: "No se pudieron obtener las entradas del blog.", error });
			});
	}, [refresh]);

	return (
		<>
			<Card>
				<CardHeader title="Entradas del blog">
					<CardHeaderToolbar>
						<button
							type="button"
							className="btn btn-primary"
							onClick={() => history.push("/edit-blog-post")}
						>
							Nueva entrada
						</button>
					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					<Table data={data} columns={columns} />
					<ConfirmDialog
						title={"¿Seguro que quieres eliminar esta entrada?"}
						open={openConfirmDialog}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deleteBlogPost(postId)
								.then((res) => {
									if (res.status === 204) {
										alertSuccess({
											title: "Eliminado",
											customMessage: "Entrada eliminada correctamente.",
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({ error, customMessage: "No se pudo eliminar la entrada." });
								});
						}}
					/>
				</CardBody>
			</Card>
		</>
	);
}
